import React from 'react';
import {Formik, FormikProps, Field} from 'formik';

import {Form, Button} from '@components';
import validations from '@validations';
import {Props} from './types';
import _Base from './../_Base';
import * as handlers from './handlers';

import './index.scss';

const ChangePassword: React.FC<Props> = props => {
  const initialValues = {
    currentPassword: '',
    password: '',
    confirmPassword: '',
    email: '',
  };

  return (
    <_Base
      size="lg"
      handleCloseModal={props.handleCloseModal}
      isModal={props.isModal}
      isAutoClose={false}
      title={props.title}
    >
      <div className="a__change-password-modal">
        {props.isInitial ? (
          <div className="b__message">
            <p>AnpiCheckerにログインする為には、</p>
            <p>
              特権管理者者に指定された初期パスワードを変更する必要があります。
            </p>
            <p>
              AnpiCheckerにログインする為の新しいパスワードを入力して下さい。
            </p>
          </div>
        ) : null}
        <Formik
          initialValues={initialValues}
          enableReinitialize
          onSubmit={
            props.handleSubmit
              ? props.handleSubmit
              : async (value: any, helper: any) => {
                  await handlers.changePassword(
                    value,
                    helper,
                    props.handleCloseModal
                  );
                }
          }
          validate={
            props.isInitial
              ? validations.users.resetInitialPassword
              : validations.users.changePassword
          }
        >
          {(formProps: FormikProps<any>) => {
            return (
              <>
                {props.isInitial ? null : (
                  <Field
                    component={Form.Input}
                    name="currentPassword"
                    placeholder={'現在のパスワード'}
                    type="password"
                  />
                )}
                <Field
                  component={Form.Input}
                  name="password"
                  placeholder="新しいパスワード"
                  type="password"
                />
                <Field
                  component={Form.Input}
                  name="confirmPassword"
                  placeholder="新しいパスワード (確認用)"
                  type="password"
                />
                <Button.Normal
                  color="yellow"
                  text="パスワードを変更する"
                  disabled={formProps.isSubmitting}
                  loading={formProps.isSubmitting}
                  onClick={() => formProps.handleSubmit()}
                />
              </>
            );
          }}
        </Formik>
      </div>
    </_Base>
  );
};

export default ChangePassword;
